import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import CoopServicesContent from './components/CoopServicesContent';

export default function CoopServicesPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '合作服務｜法規風控・行銷文案・原料代尋・快速上市｜康永生技',
    description: '康永生技提供全方位合作服務：法規風險控管、行銷文案撰寫、進口原料代尋、快速市場上市策略，幫助品牌穩健成長。',
    keywords: '合作服務,法規風險,行銷文案,原料代尋,快速上市,保健食品代工服務',
    lang: 'zh-TW',
    canonicalPath: '/cooperation/services',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="合作服務｜法規風控・行銷文案・原料代尋・快速上市｜康永生技" pageDescription="康永生技提供全方位合作服務：法規風險控管、行銷文案撰寫、進口原料代尋、快速市場上市策略，幫助品牌穩健成長。" pageUrl={`${siteUrl}/cooperation/services`} />
      <CoopServicesContent />
    </Layout>
  );
}